import { render, staticRenderFns } from "./UnavailabilityPeriods.vue?vue&type=template&id=f17f1c4a&scoped=true&"
import script from "./UnavailabilityPeriods.vue?vue&type=script&lang=js&"
export * from "./UnavailabilityPeriods.vue?vue&type=script&lang=js&"
import style0 from "./UnavailabilityPeriods.vue?vue&type=style&index=0&id=f17f1c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17f1c4a",
  null
  
)

export default component.exports